import { render, staticRenderFns } from "./MobileIconButton.vue?vue&type=template&id=4f0cfb80&scoped=true"
import script from "./MobileIconButton.vue?vue&type=script&lang=js"
export * from "./MobileIconButton.vue?vue&type=script&lang=js"
import style0 from "./MobileIconButton.vue?vue&type=style&index=0&id=4f0cfb80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0cfb80",
  null
  
)

export default component.exports